import React from 'react';

interface SitooLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const SitooLogo: React.FC<SitooLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 30"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* White background */}
        <rect
          x="0"
          y="0"
          width="100"
          height="30"
          fill="#ffffff"
        />
        
        {/* Sitoo text */}
        <text
          x="15"
          y="20"
          fontSize="14"
          fontWeight="bold"
          fill="#374151"
          fontFamily="Arial, sans-serif"
        >
          sitoo
        </text>
        
        {/* Five-petal flower/star symbol */}
        <g transform="translate(70, 15)">
          {/* Top petal - Red */}
          <path
            d="M 0 -8 L 3 -3 L 0 0 L -3 -3 Z"
            fill="#dc2626"
          />
          
          {/* Upper-right petal - Orange */}
          <path
            d="M 3 -3 L 8 -3 L 5 0 L 3 0 Z"
            fill="#ea580c"
          />
          
          {/* Lower-right petal - Dark blue */}
          <path
            d="M 8 -3 L 8 3 L 5 0 L 5 0 Z"
            fill="#1e40af"
          />
          
          {/* Lower-left petal - Teal/Green */}
          <path
            d="M 0 0 L 5 0 L 3 3 L 0 0 Z"
            fill="#0d9488"
          />
          
          {/* Upper-left petal - Purple */}
          <path
            d="M -3 -3 L 0 0 L 0 0 L -3 -3 Z"
            fill="#7c3aed"
          />
          
          {/* White center */}
          <circle cx="0" cy="0" r="2" fill="#ffffff"/>
        </g>
      </svg>
    </div>
  );
};

export default SitooLogo;


